'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet from "./java.util.-Hash-Map$-Entry-Set.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dNode from "./java.util.-Hash-Map$-Node.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dNode$002dIterator from "./java.util.-Hash-Map$-Node-Iterator.js";
import * as $j_java$002eutil$002e$002dMap from "./java.util.-Map.js";
var $p;
/** @constructor */
function $c_ju_AbstractMap() {
}
export { $c_ju_AbstractMap as $c_ju_AbstractMap };
$p = $c_ju_AbstractMap.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
}
export { $h_ju_AbstractMap as $h_ju_AbstractMap };
$h_ju_AbstractMap.prototype = $p;
$p.xW = (function(m) {
  var _\uff3fself = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet.$c_ju_HashMap$EntrySet(m);
  var _\uff3fself$1 = _\uff3fself.cV();
  while (_\uff3fself$1.i()) {
    var t = _\uff3fself$1.e();
    var key = t.ek;
    var $x_2 = t.dn;
    if ((key === null)) {
      var $x_1 = 0;
    } else {
      var originalHash = $j_java$002elang$002e$002dObject.$dp_hashCode__I(key);
      var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    this.dO(key, $x_2, $x_1, false);
  }
});
$p.f = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($j_java$002eutil$002e$002dMap.$is_ju_Map(o)) {
    if ((this.ga === o.ga)) {
      var _\uff3fself = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet.$c_ju_HashMap$EntrySet(this);
      var _\uff3fself$1 = _\uff3fself.cV();
      _return: {
        while (_\uff3fself$1.i()) {
          var t = _\uff3fself$1.e();
          var a = $p_ju_HashMap__getOrDefaultImpl__O__O__O(o, t.ek, null);
          var b = t.dn;
          if ((!((a === null) ? (b === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(a, b)))) {
            var $x_1 = true;
            break _return;
          }
        }
        var $x_1 = false;
      }
      return (!$x_1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  var _\uff3fself = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet.$c_ju_HashMap$EntrySet(this);
  var _\uff3fself$1 = _\uff3fself.cV();
  var result = 0;
  while (_\uff3fself$1.i()) {
    var t = result;
    var u = _\uff3fself$1.e();
    var t$1 = (t | 0);
    result = ((u.m() + t$1) | 0);
  }
  return (result | 0);
});
$p.b = (function() {
  var result = "{";
  var first = true;
  var iter = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet.$c_ju_HashMap$EntrySet(this).cV();
  while (iter.i()) {
    var entry = iter.e();
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (((("" + result) + entry.ek) + "=") + entry.dn);
  }
  return (result + "}");
});
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $j_java$002elang$002e$002dObject.$dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var node = $thiz.ue(key, hash, (hash & (($thiz.dm.a.length - 1) | 0)));
  return ((node === null) ? defaultValue : node.dn);
}
export { $p_ju_HashMap__getOrDefaultImpl__O__O__O as $p_ju_HashMap__getOrDefaultImpl__O__O__O };
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.dm;
  var oldlen = oldTable.a.length;
  var newlen = (oldlen << 1);
  var newTable = new ($j_java$002eutil$002e$002dHash$002dMap$0024$002dNode.$d_ju_HashMap$Node.r().C)(newlen);
  $thiz.dm = newTable;
  $thiz.zR = $j_java$002elang$002e$002dObject.$doubleToInt((newlen * $thiz.zQ));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = oldTable.a[i];
    while ((node !== null)) {
      if (((node.hK & oldlen) === 0)) {
        node.m3 = lastLow;
        if ((lastLow === null)) {
          newTable.a[i] = node;
        } else {
          lastLow.fw = node;
        }
        lastLow = node;
      } else {
        node.m3 = lastHigh;
        if ((lastHigh === null)) {
          newTable.a[((oldlen + i) | 0)] = node;
        } else {
          lastHigh.fw = node;
        }
        lastHigh = node;
      }
      node = node.fw;
    }
    if ((lastLow !== null)) {
      lastLow.fw = null;
    }
    if ((lastHigh !== null)) {
      lastHigh.fw = null;
    }
    i = ((1 + i) | 0);
  }
}
export { $p_ju_HashMap__growTable__V as $p_ju_HashMap__growTable__V };
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.zQ = loadFactor;
  if ((initialCapacity < 0)) {
    $j_java$002elang$002e$002dObject.$m_jl_BoundsChecks$().Pn(initialCapacity);
  }
  if ((loadFactor <= 0.0)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), "loadFactor <= 0.0");
  }
  var a = ((initialCapacity - 1) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  $thiz.dm = new ($j_java$002eutil$002e$002dHash$002dMap$0024$002dNode.$d_ju_HashMap$Node.r().C)(((a$1 < 1073741824) ? a$1 : 1073741824));
  $thiz.zR = $j_java$002elang$002e$002dObject.$doubleToInt(($thiz.dm.a.length * $thiz.zQ));
  $thiz.ga = 0;
  return $thiz;
}
export { $ct_ju_HashMap__I__F__ as $ct_ju_HashMap__I__F__ };
function $ct_ju_HashMap__($thiz) {
  $ct_ju_HashMap__I__F__($thiz, 16, 0.75);
  return $thiz;
}
export { $ct_ju_HashMap__ as $ct_ju_HashMap__ };
/** @constructor */
function $c_ju_HashMap() {
  this.zQ = 0.0;
  this.dm = null;
  this.zR = 0;
  this.ga = 0;
}
export { $c_ju_HashMap as $c_ju_HashMap };
$p = $c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$p.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
}
export { $h_ju_HashMap as $h_ju_HashMap };
$h_ju_HashMap.prototype = $p;
$p.aj = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $j_java$002elang$002e$002dObject.$dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return (this.ue(key, hash, (hash & ((this.dm.a.length - 1) | 0))) !== null);
});
$p.xW = (function(m) {
  if ((m instanceof $c_ju_HashMap)) {
    var iter = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dNode$002dIterator.$c_ju_HashMap$NodeIterator(m);
    while (iter.i()) {
      var next = iter.e();
      this.dO(next.ek, next.dn, next.hK, false);
    }
  } else {
    $c_ju_AbstractMap.prototype.xW.call(this, m);
  }
});
$p.aa = (function(key) {
  var node = this.Pu(key);
  return ((node === null) ? null : node.dn);
});
$p.ue = (function(key, hash, idx) {
  var node = this.dm.a[idx];
  while (true) {
    if ((node === null)) {
      return null;
    } else {
      if ((hash === node.hK)) {
        var b = node.ek;
        var $x_1 = ((key === null) ? (b === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return node;
      } else if ((hash < node.hK)) {
        return null;
      } else {
        node = node.fw;
      }
    }
  }
});
$p.dO = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ga) | 0);
  if ((newContentSize >= this.zR)) {
    $p_ju_HashMap__growTable__V(this);
  }
  var idx = (hash & ((this.dm.a.length - 1) | 0));
  var x1 = this.dm.a[idx];
  if ((x1 === null)) {
    var newNode = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dNode.$c_ju_HashMap$Node(key, hash, value, null, null);
    this.dm.a[idx] = newNode;
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.hK <= hash))) {
      if ((n.hK === hash)) {
        var b = n.ek;
        var $x_1 = ((key === null) ? (b === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var old = n.dn;
        if (((!ifAbsent) || (old === null))) {
          n.dn = value;
        }
        return old;
      }
      prev = n;
      n = n.fw;
    }
    var newNode$2 = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dNode.$c_ju_HashMap$Node(key, hash, value, prev, n);
    if ((prev === null)) {
      this.dm.a[idx] = newNode$2;
    } else {
      prev.fw = newNode$2;
    }
    if ((n !== null)) {
      n.m3 = newNode$2;
    }
  }
  this.ga = newContentSize;
  return null;
});
$p.Pu = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $j_java$002elang$002e$002dObject.$dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var idx = (hash & ((this.dm.a.length - 1) | 0));
  var node = this.ue(key, hash, idx);
  if ((node !== null)) {
    this.BV(node, idx);
  }
  return node;
});
$p.WW = (function(node) {
  this.BV(node, (node.hK & ((this.dm.a.length - 1) | 0)));
});
$p.BV = (function(node, idx) {
  var previous = node.m3;
  var next = node.fw;
  if ((previous === null)) {
    this.dm.a[idx] = next;
  } else {
    previous.fw = next;
  }
  if ((next !== null)) {
    next.m3 = previous;
  }
  this.ga = ((this.ga - 1) | 0);
});
function $isArrayOf_ju_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dQ)));
}
export { $isArrayOf_ju_HashMap as $isArrayOf_ju_HashMap };
var $d_ju_HashMap = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_HashMap, "java.util.HashMap", ({
  dQ: 1,
  mO: 1,
  ci: 1,
  a: 1,
  J: 1
}));
export { $d_ju_HashMap as $d_ju_HashMap };
